import { TableHead } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import axios from "axios";
// import { DataGrid } from '@mui/x-data-grid';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { TextField } from "@mui/material";
import Chip from "@mui/material/Chip";
import "./AdminComponents.scss";
import { toast } from "react-toastify";
import { Grid, Button } from "@mui/material";
import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import StoreSelectField, { toStoresPayload } from "./StoreSelectField";


// get_all_users_list/ returns a row `type`; edit_user/ wants the display
// user_type. A row whose type is missing here (a doctor) is edited from its own
// screen, so no Edit button is offered for it.
const EDITABLE_USER_TYPES = {
  facility_user: "Facility User",
  pharmacy_user: "Pharmacy User",
  lab_user: "Lab User",
  inventory_user: "Inventory User",
};

const resolveUserType = (row) =>
  row?.type === "facility_user" && row?.facility_admin === true
    ? "Facility Admin"
    : EDITABLE_USER_TYPES[row?.type] || "";

function UserDetails({ refreshList }) {
  const [userData, setUserData] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
  const [userIdToReactivate, setUserIdToReactivate] = useState(null);
  const history = useHistory();

  const [editingUserData, setEditingUserData] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const roleType = sessionStorage.getItem("roleType");
  // useEffect(() => {
  //     if ((sessionStorage.getItem('accessToken') == undefined && sessionStorage.getItem('accessToken') == null)
  //         || sessionStorage.getItem("roleType") !== "admin") {
  //         history.push('/login')
  //     }
  // }, [])
  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");

    if (
      !accessToken
      //  ||
      // (roleType !== "admin" &&
      //   roleType !== "facility admin" &&
      //   roleType !== "customer admin" &&
      //   roleType !== "partner admin")
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const getRowClassName = (params) => {
    return "custom-row";
  };

  const fetchUserList = () => {
    const facilityName = sessionStorage.getItem("facility_name");
    const customerName = sessionStorage.getItem("customer_name");
    const partnerId = sessionStorage.getItem("partner_id");

    const post_data = {
      role_type: roleType,
      facility_name: facilityName,
      customer_name: customerName,
      partner_id: partnerId,
    };
    console.log("Facility Name:", facilityName);
    console.log("Role Type:", roleType);
    console.log("Customer Name:", customerName);
    console.log("Partner ID:", partnerId);
    if (
      (roleType === "admin" ||
        roleType === "customer admin" ||
        roleType === "partner admin" ||
        roleType === "facility admin") &&
      Token()
    ) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_users_list/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("data_user", res.data);
          const updatedUserData = res.data.user_list.map((user) => {
            // Replace empty or null fields with "-"
            return {
              id: user.id || "-",
              type: user.type || "-",
              username: user.username || "-",
              email: user.email || "-",
              first_name: user.first_name || "-",
              last_name: user.last_name || "-",
              partner: user.partner || "-",
              client: user.client || "-",
              facility_admin: user.facility_admin || "-",
              facility_name: user.facility_name || "-",
              address: user.address || "-",
              date_of_creation: user.date_of_creation || "-",
              active: user.active !== undefined ? user.active : "-",
              salutation: user.salutation || "-",
              role: user.role || "-",
              store_ids: Array.isArray(user.store_ids)
                ? user.store_ids
                : (user.store || user.store_id
                  ? [user.store || user.store_id]
                  : []),
              store_names: Array.isArray(user.store_names) ? user.store_names : [],
            };
          });
          setUserData(updatedUserData);
          // setUserData(updatedUserData);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };
  useEffect(() => {
    fetchUserList();
  }, [authToken, refreshList]);

  const handleDeleteUser = (userId) => {
    setUserIdToDelete(userId);
    setIsModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (userIdToDelete) {
      console.log("deleting..", userIdToDelete);

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}deactivate_facility_user/${userIdToDelete.id}/`,
          { type: userIdToDelete.type },
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            console.log("User deleted successfully:", res.data);
            toast.success("User Deleted Successfully");
            fetchUserList();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error("Error deleting user:", err);
        })
        .finally(() => {
          setUserIdToDelete(null);
          setIsModalOpen(false);
        });
    }
  };

  const isUserAdmin = () => {
    return roleType === "admin";
  };
  const handleReactivateUser = (userId) => {
    setUserIdToReactivate(userId);
    setIsReactivateModalOpen(true);
  };

  const handleConfirmReactivate = () => {
    if (userIdToReactivate) {
      console.log("reactivating..", userIdToReactivate);

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}activate_facility_user/${userIdToReactivate.id}/`,
          { type: userIdToReactivate.type },
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            console.log("User reactivated successfully:", res.data);
            toast.success("User Activated Successfully");
            fetchUserList();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error("Error reactivating user:", err);
          toast.error("Error reactivating user");
        })
        .finally(() => {
          setUserIdToReactivate(null);
          setIsReactivateModalOpen(false);
        });
    }
  };

  const handleCancelReactivate = () => {
    setUserIdToReactivate(null);
    setIsReactivateModalOpen(false);
  };

  const handleCancelDelete = () => {
    setUserIdToDelete(null);
    setIsModalOpen(false);
  };

  const handleEditUser = (user) => {
    // The list swaps empty fields for "-", which must not be written back.
    const clean = (value) => (value && value !== "-" ? value : "");
    setEditingUserData({
      ...user,
      username: clean(user.username),
      first_name: clean(user.first_name),
      last_name: clean(user.last_name),
      email: clean(user.email),
      stores: Array.isArray(user.store_ids) ? user.store_ids.map(String) : [],
    });
    setIsEditModalOpen(true);
  };

  const handleUserEditSubmit = (editedUserData) => {
    const userType = resolveUserType(editedUserData);
    if (!userType) {
      toast.error("This user type cannot be edited here.");
      return;
    }

    const post_data = {
      username: editedUserData.username,
      user_type: userType,
      // A facility admin keeps the facility id in `facility_name` — the same
      // value fetchUserList sends — and edit_user/ checks it against the
      // user's own facility.
      facility_id:
        sessionStorage.getItem("facility_id") ||
        sessionStorage.getItem("facility_name") ||
        "",
      first_name: editedUserData.first_name,
      last_name: editedUserData.last_name,
      email: editedUserData.email,
    };
    // edit_user/ rejects an empty `stores` ("Store is required") and leaves the
    // assignment alone when the key is missing, so it is sent only when set.
    const storeIds = toStoresPayload(editedUserData.stores);
    if (storeIds.length) {
      post_data.stores = storeIds;
    }

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}edit_user/`,
        JSON.stringify(post_data),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.data.status === "Success") {
          toast.success(res.data.message || "User Updated Successfully");
          setIsEditModalOpen(false);
          fetchUserList();
        } else {
          toast.error(
            res.data.error || res.data.message || "User Not Updated !!"
          );
        }
      })
      .catch((err) => {
        console.error("Error updating user:", err);
        toast.error(err?.response?.data?.message || "Error updating user");
      });
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };

  const allColumns = [
    { field: "username", headerName: "User Name", width: 120 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "salutation", headerName: "salutation", width: 100 },
    { field: "first_name", headerName: "First Name", width: 150 },
    { field: "last_name", headerName: "Last Name", width: 150 },
    // { field: "partner", headerName: "Partner Name", width: 150 },
    // { field: "client", headerName: "Customer Name", width: 150 },
    { field: "facility_name", headerName: "Facility Name", width: 150 },
    { field: "role", headerName: "Role Type", width: 150 },
    {
      field: "store_ids",
      headerName: "Stores",
      width: 240,
      renderCell: (params) => {
        const ids = Array.isArray(params.value) ? params.value : [];
        const names = Array.isArray(params.row.store_names) ? params.row.store_names : [];
        if (!ids.length) return "—";
        return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
            {ids.map((id, i) => (
              <Chip key={id} size="small" label={names[i] || id} />
            ))}
          </Box>
        );
      },
    },
    {
      field: "type",
      headerName: "Type",
      width: 180,
      renderCell: (params) => {
        if (roleType === "facility admin") {
          switch (params.value) {
            case "facility_user":
              return "Facility User";
            case "pharmacy_user":
              return "Pharmacy User";
            case "lab_user":
              return "Lab User";
            case "inventory_user":
              return "Inventory User";
            default:
              return "-";
          }
        }

        if (roleType === "customer admin" || roleType === "admin") {
          if (params.value === "facility_user") {
            return params.row.facility_admin == true
              ? "Facility Admin"
              : "Facility User";
          }
          if (params.value === "pharmacy_user") {
            return "Pharmacy User";
          }

          if (params.value === "lab_user") {
            return "Lab User";
          }
          if (params.value === "inventory_user") {
            return "Inventory User";
          }
          if (params.value === "doctor_user") {
            return "Doctor";
          }

          return "-";
        }

        return "-";
      },
    },

    { field: "address", headerName: "Address", width: 180 },
    {
      field: "date_of_creation",
      headerName: "Created At",
      width: 180,
      valueFormatter: (params) => {
        const value = params?.value;

        if (!value) return "-";

        const date = new Date(value);

        // Check if the date is valid
        if (isNaN(date.getTime())) return "-";

        const formattedDate = date.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });

        const formattedTime = date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
        });

        return `${formattedDate}, ${formattedTime}`;
      },
    },
    {
      field: "active",
      headerName: "Status",
      width: 100,
      renderCell: (params) => (
        <div
          style={{ color: params.value ? "green" : "red", fontWeight: "bold" }}
        >
          {params.value ? "Active" : "Inactive"}
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <>
          {resolveUserType(params.row) && (
            <button
              onClick={() => handleEditUser(params.row)}
              style={{ color: "blue", fontWeight: "bold", marginRight: "8px" }}
            >
              Edit
            </button>
          )}
          {params.row.active ? (
            <button
              onClick={() => handleDeleteUser(params.row)}
              style={{ color: "red", fontWeight: "bold" }}
            >
              Delete
            </button>
          ) : (
            <button
              onClick={() => handleReactivateUser(params.row)}
              style={{ color: "green", fontWeight: "bold" }}
            >
              Reactivate
            </button>
          )}
        </>
      ),
    },
  ];

  // Filter columns based on role type
  const filteredColumns = allColumns.filter((column) => {
    if (roleType === "admin") return true;
    if (
      roleType === "partner admin" &&
      column.field !== "partner" &&
      column.field !== "facility_name"
    )
      return true;
    if (
      roleType === "customer admin" &&
      column.field !== "partner" &&
      column.field !== "client"
    )
      return true;
    if (
      roleType === "facility admin" &&
      column.field !== "partner" &&
      column.field !== "client" &&
      column.field !== "facility_name"
    )
      return true;
    return false;
  });

  const generatePdf = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [["UserName", "EmailID", "Salutation", "First Name", "Last Name", "Facility Name", "Role Type", "Type", "Address", "Created At", "Status",]],
      body: userData.map((ud) => [
        ud.username,
        ud.email,
        ud.salutation,
        ud.first_name,
        ud.last_name,
        ud.facility_name,
        ud.role,
        ud.type,
        ud.address,
        ud.date_of_creation,
        ud.active,
      ]),
    });
    doc.save("User_Details.pdf");
  };

  const generateCsvData = () => {
    return userData.map((ud) => ({
      UserName: ud.username,
      Email: ud.email,
      Salutation: ud.salutation,
      "First Name": ud.first_name,
      "Last Name": ud.last_name,
      "Facility Name": ud.facility_name,
      "Role Type": ud.role,
      "Type": ud.type,
      "Address": ud.address,
      "Created At": ud.date_of_creation,
      "Status": ud.active,
    }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "auto",
        width: "100%",
        maxWidth: "1200px", // Set a max width for large screens
        padding: "1rem",
      }}
    >
      <div style={{ width: "100%" }}>
        <h4 style={{ textAlign: "center" }}>User List</h4>

        <div className="display-flex">
          <DataGrid
            rows={userData}
            columns={filteredColumns}
            components={{
              Toolbar: () => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    mb: 2,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={8}
                    sx={{ display: "flex", gap: 1 }}
                  >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display: "flex",
                      gap: 1,
                      justifyContent: { xs: "center", sm: "flex-end" },
                    }}
                  >
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => generatePdf()}
                      startIcon={<SaveAlt />}
                    >
                      Download PDF
                    </Button>
                    <CSVLink
                      data={generateCsvData()}
                      filename={"patient_records.csv"}
                      target="_blank"
                    >
                      <Button
                        variant="text"
                        color="primary"
                        startIcon={<SaveAlt />}
                      >
                        Download CSV
                      </Button>
                    </CSVLink>
                  </Grid>
                </Grid>
              ),
            }}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10]}
            getRowId={(row) => row.username || `generated-id-${Math.random()}`} // Custom ID generation
            // components={{
            //   Toolbar: () => (
            //     <div style={{ display: "flex", justifyContent: "space-between" }}>
            //       <div style={{ display: "flex" }}>
            //         <GridToolbarColumnsButton />
            //         <GridToolbarFilterButton />
            //         <GridToolbarDensitySelector />
            //       </div>

            //     </div>
            //   ),
            // }}
            getRowClassName={getRowClassName}
            sx={{
              "& .MuiDataGrid-root": {
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                fontFamily: "Arial, sans-serif",
                padding: "5px"
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#125386",
                color: "white",
                fontSize: "13px",
                fontWeight: "600",
                minHeight: "48px !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white",
                  fontWeight: "600",
                  fontSize: "13px",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                  padding: "0 12px",
                },
                "& .MuiDataGrid-columnHeader:last-child": {
                  borderRight: "none",
                },
                "& .MuiDataGrid-iconButtonContainer": {
                  color: "white",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaderSortable": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "white",
                minHeight: "40px !important",
                "&:nth-of-type(even)": {
                  backgroundColor: "white",
                },
                "&:hover": {
                  backgroundColor: "#f8f9fa",
                },
                "&.Mui-selected": {
                  backgroundColor: "#e3f2fd",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                  },
                },
                borderBottom: "1px solid #e0e0e0",
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "12px",
                color: "#374151",
                padding: "8px 12px",
                minHeight: "40px !important",
                "&:last-child": {
                  borderRight: "none",
                },
                "&:focus": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-cellContent": {
                fontSize: "12px",
                color: "#374151",
                fontWeight: "400",
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #e0e0e0",
                minHeight: "52px",
              },
              "& .MuiTablePagination-root": {
                color: "#374151",
                fontSize: "12px",
              },
              "& .MuiDataGrid-toolbarContainer": {
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                padding: "8px 16px",
              },
            }}
          />
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onClose={handleCancelDelete}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="confirm-delete-modal"
        aria-describedby="confirm-delete-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: {
              xs: "98%", // Mobile
              sm: "85%", // Tablet
              md: "70%", // Small desktop
              lg: "60%", // Large desktop
            },
            maxWidth: "700px",
            // minHeight: {
            //   xs: "200px", // Mobile
            //   sm: "250px", // Tablet
            //   md: "300px", // Small desktop
            //   lg: "350px", // Large desktop
            // },
          }}
        >
          <h3 id="confirm-delete-modal" style={{ marginTop: 0, fontSize: "32px" }}>
            Confirm Deletion
          </h3>
          <p id="confirm-delete-description" style={{ fontSize: "20px" }}>
            Are you sure you want to delete this user?
          </p>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              mt: "10%",
            }}
          >
            <Button
              onClick={handleCancelDelete}
              className="button button-contained-cancel"
              sx={{
                backgroundColor: "#FFBD8A", padding: "8px 14px", border: "1px solid #FF8D28", borderRadius: "10px", color: "#000000", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#FFBD8A", // Maintain same background color on hover
                  border: "1px solid #FF8D28", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#A1DA3B",
                padding: "8px 14px",
                border: "1px solid #8DC63F",
                borderRadius: "10px",
                color: "#000000",
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#A1DA3B", // Maintain same background color on hover
                  border: "1px solid #8DC63F", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CONFIRM DELETION
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={isReactivateModalOpen}
        onClose={handleCancelReactivate}
        style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="confirm-reactivate-modal"
        aria-describedby="confirm-reactivate-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            border: "2px solid #000",
            borderRadius: "20px",
            padding: { xs: "16px", sm: "20px" },
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: {
              xs: "98%", // Mobile
              sm: "85%", // Tablet
              md: "70%", // Small desktop
              lg: "60%", // Large desktop
            },
            maxWidth: "700px",
            // minHeight: {
            //   xs: "200px", // Mobile
            //   sm: "250px", // Tablet
            //   md: "300px", // Small desktop
            //   lg: "350px", // Large desktop
            // },
          }}
        >
          <h3 id="confirm-reactivate-modal" style={{ marginTop: 0, fontSize: "32px" }}>
            Confirm Reactivation
          </h3>
          <p id="confirm-reactivate-description" style={{ fontSize: "20px" }}>
            Are you sure you want to reactivate this user?
          </p>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              mt: "10%",
            }}
          >
            <Button
              onClick={handleCancelReactivate}
              className="button button-contained-cancel"
              sx={{
                backgroundColor: "#FFBD8A", padding: "8px 14px", border: "1px solid #FF8D28", borderRadius: "10px", color: "#000000", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#FFBD8A", // Maintain same background color on hover
                  border: "1px solid #FF8D28", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleConfirmReactivate}
              sx={{
                backgroundColor: "#A1DA3B",
                padding: "8px 14px",
                border: "1px solid #8DC63F",
                borderRadius: "10px",
                color: "#000000",
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
                "&:hover": {
                  backgroundColor: "#A1DA3B", // Maintain same background color on hover
                  border: "1px solid #8DC63F", // Maintain border color
                  boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)", // Maintain shadow
                },
                flex: "1", minWidth: 0,
              }}
            >
              CONFIRM REACTIVATION
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={isEditModalOpen}
        onClose={handleModalClose}
        aria-labelledby="edit-user-modal"
        aria-describedby="edit-user-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            border: "2px solid #000",
            borderRadius: "8px",
            padding: "20px",
            boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
            width: "500px",
            margin: "0 auto",
          }}
        >
          <h2 id="edit-user-modal">Edit User</h2>
          {editingUserData && (
            <form>
              <TextField
                label="Username"
                value={editingUserData.username}
                onChange={(e) =>
                  setEditingUserData({
                    ...editingUserData,
                    username: e.target.value,
                  })
                }
                fullWidth
                style={{ marginBottom: "15px" }}
              />
              <TextField
                label="Email"
                value={editingUserData.email}
                onChange={(e) =>
                  setEditingUserData({
                    ...editingUserData,
                    email: e.target.value,
                  })
                }
                fullWidth
                style={{ marginBottom: "15px" }}
              />
              <TextField
                label="First Name"
                value={editingUserData.first_name}
                onChange={(e) =>
                  setEditingUserData({
                    ...editingUserData,
                    first_name: e.target.value,
                  })
                }
                fullWidth
                style={{ marginBottom: "15px" }}
              />
              <TextField
                label="Last Name"
                value={editingUserData.last_name}
                onChange={(e) =>
                  setEditingUserData({
                    ...editingUserData,
                    last_name: e.target.value,
                  })
                }
                fullWidth
                style={{ marginBottom: "15px" }}
              />
              <div style={{ marginBottom: "15px" }}>
                <StoreSelectField
                  className=""
                  value={editingUserData.stores}
                  onChange={(ids) =>
                    setEditingUserData({ ...editingUserData, stores: ids })
                  }
                />
              </div>
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleUserEditSubmit(editingUserData);
                }}
                variant="contained"
                style={{
                  backgroundColor: "#213360",
                  color: "#fff",
                  border: "2px solid #213360",
                  borderRadius: "20px",
                  marginTop: "10px",
                }}
              >
                Save Changes
              </Button>
            </form>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default UserDetails;
